import { z } from 'zod';
import { cursorQuerySchema, uuidSchema } from './common';

const i18nImageSchema = z.object({
  ko: z.string().min(1).max(500),
  ja: z.string().min(1).max(500),
});

export const upsertBannerSchema = z.object({
  title: z.string().min(1).max(100),
  imageI18n: i18nImageSchema,
  linkType: z.enum(['product', 'request', 'url', 'none']).default('none'),
  linkValue: z.string().max(1000).optional(),
  sortOrder: z.number().int().default(0),
  startsAt: z.string().datetime().nullable().optional(),
  endsAt: z.string().datetime().nullable().optional(),
  isActive: z.boolean().default(true),
});
export type UpsertBannerInput = z.infer<typeof upsertBannerSchema>;

export const upsertCategorySchema = z.object({
  slug: z
    .string()
    .min(1)
    .max(50)
    .regex(/^[a-z0-9-]+$/),
  nameI18n: z.object({ ko: z.string().min(1).max(50), ja: z.string().min(1).max(50) }),
  sortOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
});
export type UpsertCategoryInput = z.infer<typeof upsertCategorySchema>;

export const adminListProductsQuerySchema = cursorQuerySchema.extend({
  q: z.string().max(100).optional(),
  status: z.enum(['draft', 'published', 'archived']).optional(),
  categoryId: uuidSchema.optional(),
});
export type AdminListProductsQuery = z.infer<typeof adminListProductsQuerySchema>;
